import { Accordion, AccordionDetails, AccordionSummary, styled } from '@mui/material'

export const PropertiesAccordion = styled(Accordion)`
  box-shadow: none;

  &:before {
    background-color: #E7E9EB;
  }

  &.Mui-expanded {
    margin-top: 0;

    &:before {
      display: block !important;
      opacity: 1;
    }
  }

  .MuiAccordionSummary-root {
    padding: 0;
    font-size: 12px;
    font-weight: bold;
    min-height: 48px;

    &.Mui-expanded {
      margin: 0;
      min-height: 48px;
    }
  }

  .MuiAccordionSummary-expandIconWrapper {
    width: 10px;
    height: 7px;
    margin-right: 11px;
  }

  .MuiAccordionSummary-content, 
  .MuiAccordionSummary-content.Mui-expanded {
    margin: 17px 0;
  }
`

export const PropertiesAccordionDetails = styled(AccordionDetails)`
  padding: 0;
`

export const PropertiesAccordionSummary = ({label}:{label: string}) => {
  return <AccordionSummary id={label}
    expandIcon={<svg><use href="assets/icons/settings.svg#arrow"/></svg>}
    aria-controls={label}>
    {label}
  </AccordionSummary>
}
